import { ActionProps } from "../../ts";
import { LIST_OF_DASHBOARD, LIST_OF_DASHBOARD_ERROR } from "../ActionTypes";

const initialState = { dashboard: null };

const dashboardStore = (state: any = initialState, action: ActionProps) => {
  const { type, payload } = action;
  switch (type) {
    case LIST_OF_DASHBOARD: {
      return {
        ...state,
        dashboard: payload,
      };
    }
    case LIST_OF_DASHBOARD_ERROR: {
      return {
        ...state,
        dashboard: null,
      };
    }
    default:
      return state;
  }
};

export default dashboardStore;